import Http from '@/ship/Http';
import { IPMChartWeeklyReport } from '@/ship/Models/IProjectManagement';
import { GetRequestParams } from '@/ship/Requests/RequestParams';
import ITransformedValue from '@/ship/Values/ITransformedValue';
import { AxiosResponse } from 'axios';

export const approveWeeklyReport = (
    id: number,
    params?: GetRequestParams,
): Promise<AxiosResponse<ITransformedValue<IPMChartWeeklyReport>>> =>
    Http.get(`/project-management/charts/weekly-report/${id}/approve`, { params });
